<template>
  <v-card flat>
    <v-card-text class="text-center">
      <v-btn link text class="color_breadcrumbs--text" @click="changeTab(0)">
        <template v-if="paramsRob.robId === null">
          <span class="font-weight-bold">
            <v-icon color="teal">mdi-magnify</v-icon>
            {{ items()[0] }}
          </span>
        </template>
        <template v-else>
          <v-icon color="teal"> mdi-check </v-icon>
          {{ items()[0] }}
        </template>
      </v-btn>
      <v-btn
        v-if="paramsRob.robId !== null"
        link
        text
        class="color_breadcrumbs--text"
        @click="changeTab(1)"
      >
        <template v-if="paramsRob.structureId === null">
          <span class="font-weight-bold">
            <v-icon color="teal">mdi-magnify</v-icon>
            {{ items()[1] }}
          </span>
        </template>
        <template v-else>
          <v-icon color="teal"> mdi-check </v-icon>
          {{ items()[1] }}
        </template>
      </v-btn>
      <v-btn
        v-if="paramsRob.robId !== null && paramsRob.structureId !== null"
        link
        text
        class="color_breadcrumbs--text"
        @click="changeTab(2)"
      >
        <template v-if="paramsRob.carteId === null">
          <span class="font-weight-bold">
            <v-icon color="teal">mdi-magnify</v-icon>
            {{ items()[2] }}
          </span>
        </template>
        <template v-else>
          <v-icon color="teal"> mdi-check </v-icon>
          {{ items()[2] }}
        </template>
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { generalMixin } from "@/mixins/general";
import { robMixin } from "@/mixins/rob";
import { structureMixin } from "@/mixins/structure";
import { carteMixin } from "@/mixins/carte";

export default {
  name: "VueMyBreadCrumbs",
  mixins: [generalMixin, robMixin, structureMixin, carteMixin],
  methods: {
    items() {
      return [
        this.paramsRob.robId !== null
          ? "ROB" + " (" + this.breadCrumbs.rob.toUpperCase() + ")"
          : this.$i18n.tc("breadCrumbs.rob"),
        this.paramsRob.structureId !== null
          ? "STRUCTURE " + " (" + this.breadCrumbs.structure.toUpperCase() + ")"
          : this.$i18n.tc("breadCrumbs.structure"),
        this.paramsRob.carteId !== null
          ? "CARTE" + " (" + this.breadCrumbs.carte.toUpperCase() + ")"
          : this.$i18n.tc("breadCrumbs.carte"),
      ];
    },
    changeTab(i) {
      switch (i) {
        case 0:
          this.getRobs();
          this.paramsRob.robId = null;
          this.paramsRob.structureId = null;
          this.paramsRob.carteId = null;
          break;
        case 1:
          this.paramsRob.structureId = null;
          this.paramsRob.carteId = null;
          this.getStructures(this.paramsRob.robId);
          break;
        case 2:
          this.paramsRob.carteId = null;
          this.getRobCartes({
            robId: this.paramsRob.robId,
            structureId: this.paramsRob.structureId,
          });
          break;
      }
      this.affichage.rob = "tab-" + (i + 1);
    },
  },
};
</script>

<style scoped></style>
